import React, { useEffect, useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Container,Button} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { DeleteForever, Remove} from '@mui/icons-material';

const DescriptionText = ({text,limit,color,font,size,margin})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography m={margin || 0} style={{fontSize:size,color:color,fontFamily:(font || null)}}> {displayText} </Typography>
  }

const CustomDialog = ({visible,setVisible,title,massDisabled,data,setData,handleUserDelete,deleting})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch()
    // const [deleting,setDeleting] = useState(false)

	const onOpen = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};

return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="space-between" alignContent="center">
				<Box display="flex" flexDirection="row">
					<IconButton sx={{marginTop:3}}>
						<MenuIcon/>
					</IconButton>					
					<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
						Participants
					</Typography>	
				</Box>
				<IconButton disabled={massDisabled || false} onClick={(e)=>{
					setData([])
				}} sx={{marginTop:3}}>
					<DeleteForever sx={{color:"red"}}/>
				</IconButton>
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{height:800,width:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
			 {
				data?.length == 0 && (
					<Box>
						<Typography m={1} style={{fontSize:15,fontWeight:400,color:"gold"}}>
							Participants list is empty
						</Typography>
					</Box>
				)
			 }
			{
				data?.map((item,index)=>{
					return(
						<Box mt={2} key={index}>
							<Box sx={{ display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",width:"90%"}}>
							    <Typography  mt={1} style={{fontSize:15,fontWeight:400}}>
									# {index+1}
								</Typography>
								<Box textAlign="center" >
									<DescriptionText limit={30} size={11} font="dinofans" color="gold" text={`${item?.first_name} ${item?.last_name}`} />
									<DescriptionText margin={1} limit={30} size={13}  color="grey" text={item?.email}/>								
								</Box>
								<IconButton onClick={async(e)=>{
									e?.preventDefault()
									handleUserDelete(item?.email)
								}}>
									{
										deleting ?
											<Typography sx={{fontSize:10,color:"red"}}>
												Deleting
											</Typography>
										:
											<Remove fontSize="small" sx={{color:"red"}}/>
									}
								</IconButton>								
							</Box>
						</Box>
					)
				})
			}
		</DialogContent>
	</Dialog>
	)
}

export default CustomDialog;